import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import classnames from 'classnames';
import { get, filter, isEmpty, map, reduce, includes } from 'lodash';
import AddressFormatter from '@shopify/address';
import ReviewSpaceRentalTable from '../elements-tables/review-space-rental-table';
import { CTAButton } from 'shared-components/buttons/cta-button';
import PriceTable from '../elements-tables/price-table';
import TextButton from '../elements-buttons/text-button';
import AddOnsTable from '../app-main/components/reduxForms/fieldSets/AddOnsTable/add-ons-table';
import { Helpers } from 'shared-components/helpers/helpers';
import moment from 'moment';
import VatMessage from '../app-bookings-custom/vat-message';
import { FormattedDate } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { Fees } from 'api/api-fees';
import { regions } from './data/regions-data';
import {
  intlTaxFeeCopy,
  intlViewInvoicesLinkText,
  intlViewInvoiceLinkTextWebview
} from './data/translations-data';
import { fetchInvoiceEntriesByBkg } from '../app-main/actions/invoices';
import { PaymentsTable } from '../elements-tables/payments-table/PaymentsTable';
import { BookingSummary } from '../elements-summaries/booking-summary/BookingSummary';

class CurrentDetailsMain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      billingAddress: {},
      isVatCountry: false,
      invoiceIds: [],
      allCountries: {}
    };
  }

  componentWillMount() {
    const {
      accessToken,
      ssoId,
      masterContract,
      dispatch,
      iosWebView,
      bookingId
    } = this.props;
    const guestSsoId = get(masterContract, 'guest_sso_id', '');
    const isGuest = ssoId === guestSsoId;
    const userCalculations = isGuest
      ? get(masterContract, 'calculations.guest', {})
      : get(masterContract, 'calculations.host', {});

    const userBillingProfile = filter(
      get(userCalculations, 'profiles', []),
      (profile) => {
        return 'BILLING' === profile.type;
      }
    );

    const feeProfileCountry = get(userBillingProfile, '[0].country', '');

    // Need to fetch regional fees here instead of container component
    // due to profile not loading before componentDidMount in container component

    Fees.fetchRegionalFees(
      accessToken,
      { country: feeProfileCountry },
      (regionalFees) => {
        const isVatCountry = !isEmpty(get(regionalFees, 'fees', []));

        if (200 === get(regionalFees, 'statusCode')) {
          this.setState({
            fetchedRegionalFees: true,
            isVatCountry
          });
        }

        if (iosWebView) {
          const locale =
            'undefined' !== typeof navigator ? navigator.language : '';
          // Use shopify library to get localized country names
          const localAddressFormatter = new AddressFormatter(locale);
          localAddressFormatter.getCountries().then((countries) => {
            const countriesObj = reduce(countries, (resultObj, country) => {
              resultObj[country.code] = country;
              return resultObj;
            });

            this.setState({
              allCountries: countriesObj,
              billingAddress: userBillingProfile[0]
            });
          });

          dispatch(
            fetchInvoiceEntriesByBkg(accessToken, ssoId, bookingId)
          ).then((data) => {
            if (200 === data.statusCode) {
              const invoiceIds = Object.keys(data.entries).sort().reverse();

              this.setState({
                invoiceIds
              });
            }
          });
        }
      }
    );
  }

  render() {
    const {
      booking = {},
      cleaningFee = '',
      currency = '',
      activityDetailBooking = {},
      spaceRentalSubtotal = 0,
      spaceRentalTotal = 0,
      itemsArray = [],
      adjustmentsArray = [],
      addOnsTotal = 0,
      subtotal = 0,
      processingFee = 0,
      total = 0,
      iosWebView,
      toggleModal,
      isHost,
      masterContract = {},
      ssoId = '',
      whichModal = '',
      closeIOSModal = null,
      redirectToInboxDetails = null,
      isHostUpdate = false,
      hostAddOnsSummary = {},
      payment = {},
      downloadToPDF = null,
      pdfProcessing = false,
      cancelledTotal = 0,
      cancelledRefund = 0,
      discounts = [],
      intl,
      isVatEnabled = false,
      env = {},
      invoices = {},
      normalizedContracts,
      profile
    } = this.props;

    const { isVatCountry, invoiceIds, allCountries } = this.state;
    const country = get(activityDetailBooking, 'listing.country', '');
    const locale = 'undefined' !== typeof navigator ? navigator.language : '';
    const localeCountry = locale.split('-')[1];
    const invoiceId = get(masterContract, 'invoice_id', null);
    const lastUpdated = get(booking, 'date_modified', '');
    const bookingState = get(booking, 'obj_state', '');
    const bookingId = get(booking, '_id', '');
    const isBookingAccepted = !includes(
      ['REQUESTED', 'OFFER_SUBMITTED', 'INQUIRED'],
      bookingState
    );

    const isFnb = 'FANDB' === booking.type;
    const baseSubtotal = isFnb ? booking.base_subtotal : 0;
    const tip = isFnb ? booking.gratuity : 0;
    const tipPercent = isFnb ? booking.gratuity_percent : 0;
    const tax = isFnb ? booking.sales_tax : 0;
    const taxPercent = isFnb ? booking.sales_tax_percent : 0;

    const bookingCreatedDate = get(booking, 'date_created', '');
    const splitPaymentChargeDate = get(
      masterContract,
      'split_payment_charge_date',
      ''
    );

    const displaySplitPayments = get(
      masterContract,
      'split_payment_checkout',
      false
    );
    const guestAmounts = get(masterContract, 'calculations.guest', {});
    const splitPaymentFee = get(guestAmounts, 'split_payment.fee', 0);
    const guestSplitPayment = get(guestAmounts, 'split_payment.parts[0]', 0);
    const guestSplitPaymentWithoutFee = get(
      guestAmounts,
      'split_payment.parts[1]',
      0
    );
    const guestSplitPaymentTotal = get(guestAmounts, 'split_payment.total', 0);

    const masterCalc = get(masterContract, 'calculations', {});
    const hasConciergeItems = get(
      masterCalc,
      'concierge_add_ons_summary',
      false
    );
    // Only display add-ons summary to host if there are host provided add-ons
    const displayAddOns = isHost
      ? get(masterCalc, 'host_add_ons_summary') ||
        (addOnsTotal && !hasConciergeItems)
      : 0 < addOnsTotal;

    const billingCountry = get(this.state, 'billingAddress.country', null);
    const userCountry = billingCountry || localeCountry;
    const isEUCountry = regions.EU.includes(userCountry);

    const psAddresses = get(env, 'web.ps_addresses', {});
    const taxIntlKey = isEUCountry ? 'VAT' : 'other';
    let companyAddress = '';

    if (isEUCountry) {
      companyAddress = get(psAddresses, 'NL.address');
    } else if (psAddresses[userCountry]) {
      companyAddress = get(psAddresses[userCountry], 'address');
    } else {
      companyAddress = get(psAddresses, 'US.address');
    }

    let monthlyInvoices = {};
    if (iosWebView) {
      monthlyInvoices = get(invoices, 'bkgInvoiceEntries.entries', {});
    }
    const bookingPaymentArray = (payment?.objects || []).filter(
      (p) => p.category === 'booking'
    );

    const [processedPayments, upcomingPayments] = bookingPaymentArray.reduce(
      (paymentArrs, currPayment) => {
        if (currPayment.obj_state === 'SCHEDULED') {
          paymentArrs[1].push(currPayment);
        } else {
          paymentArrs[0].push(currPayment);
        }
        return paymentArrs;
      },
      [[], []]
    );

    return (
      <SharedIntlProviderHOC>
        <div
          id='current-details-page'
          className='CurrentDetailsMain ps-container-lg-margin ps-container-fixed'
        >
          {iosWebView && (
            <TextButton
              id='back-to-review-offer-button'
              buttonText={
                isHostUpdate
                  ? intl.formatMessage({
                      id: 'inbox.current_details_main.offer',
                      defaultMessage: 'Offer'
                    })
                  : intl.formatMessage({
                      id: 'inbox.current_details_main.booking',
                      defaultMessage: 'Booking'
                    })
              }
              icon={<div className='custom-arrow left' />}
              iconPosition='left'
              classNames='margin-md-top'
              onClick={
                closeIOSModal
                  ? closeIOSModal
                  : () => {
                      toggleModal('');
                    }
              }
            />
          )}
          <div className='ps-row'>
            <div
              className={classnames('col-xs-12 flex column', { iosWebView })}
            >
              <div className='flex space-between column-xs middle'>
                <h3>
                  {isHost ? (
                    <FormattedMessage
                      id='inbox.current_details_main.booking_details'
                      defaultMessage='Booking details'
                    />
                  ) : (
                    <FormattedMessage
                      id='inbox.current_details_main.your_receipt'
                      defaultMessage='Your Payment Receipt'
                    />
                  )}
                </h3>
                <div id='peerspace-logo' className='none'>
                  <img
                    className='receipt-logo'
                    src='https://assets.peerspace.com/ps_logo_dark-v2.svg?v=rb'
                    alt='peerspace'
                  />
                </div>
              </div>
              <div className='flex space-between column-xs'>
                <div className='text-gray-dark'>
                  <div
                    {...(Helpers.isMobile() && {
                      'data-html2canvas-ignore': 'true'
                    })}
                  >
                    <FormattedMessage
                      id='inbox.current_details_main.last_updated'
                      defaultMessage='Last Updated'
                    />{' '}
                    {
                      <FormattedDate
                        value={lastUpdated}
                        year='numeric'
                        month='short'
                        day='numeric'
                        weekday='short'
                      />
                    }
                  </div>
                  <div>
                    {invoiceId ? (
                      <FormattedMessage
                        id='inbox.current_details_main.invoice_id'
                        defaultMessage='Payment Receipt # {id}'
                        values={{ id: invoiceId }}
                      />
                    ) : null}
                  </div>
                  <div>
                    {bookingId ? (
                      <FormattedMessage
                        id='inbox.current_details_main.booking_id'
                        defaultMessage='Booking ID: {id}'
                        values={{ id: bookingId }}
                      />
                    ) : null}
                  </div>
                </div>
                {!isHost && !iosWebView && (
                  <div className='flex middle'>
                    <CTAButton
                      onClickAction={downloadToPDF}
                      buttonText={intl.formatMessage({
                        id: 'inbox.current_details_main.download_receipt',
                        defaultMessage: 'Download Receipt'
                      })}
                      classNameString='btn btn-default download-pdf'
                      isDisabled={pdfProcessing}
                      attributes={{ 'data-html2canvas-ignore': 'true' }}
                      spinning={pdfProcessing}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='ps-row'>
            <div className='col-xs-12'>
              <hr />
            </div>
          </div>
          <div className='ps-row review-container'>
            <div className='col-xs-12 col-lg-8'>
              {!isHost && (
                <h4 className='no-top-margin'>
                  <FormattedMessage
                    id='inbox.current_details_main.invoice'
                    defaultMessage='Payment Receipt'
                  />
                </h4>
              )}
              <ReviewSpaceRentalTable
                discounts={discounts}
                cleaningFee={cleaningFee || 0}
                currency={currency}
                subtotal={spaceRentalSubtotal}
                total={spaceRentalTotal}
                isFnb={isFnb}
                baseSubtotal={baseSubtotal}
                tax={tax}
                taxPercent={taxPercent}
                tip={tip}
                tipPercent={tipPercent}
                masterContract={masterContract}
              />

              {!!displayAddOns && !!addOnsTotal && (
                <AddOnsTable
                  itemsArray={itemsArray}
                  masterContract={masterContract}
                  ssoId={ssoId}
                  toggleModal={toggleModal}
                  hostAddOnsSummary={hostAddOnsSummary}
                  whichModal={whichModal}
                  currency={currency}
                  guestView={!isHost}
                  isReviewPage
                />
              )}

              <PriceTable
                currency={currency}
                spaceRentalTotal={spaceRentalTotal}
                addOnsTotal={addOnsTotal}
                hostAddOnsSummary={hostAddOnsSummary}
                total={subtotal}
                processingFee={processingFee}
                priceTotal={total}
                isHost={isHost}
                discounts={discounts}
                adjustmentsArray={adjustmentsArray}
                itemsArray={itemsArray}
                displayAddOns={displayAddOns}
                currentDetails
                bookingState={bookingState}
                cancelledTotal={cancelledTotal}
                cancelledRefund={cancelledRefund}
                splitPaymentChargeDate={splitPaymentChargeDate}
                splitPaymentFee={splitPaymentFee}
                splitPaymentAmount={guestSplitPayment}
                splitPaymentAmountWithoutFee={guestSplitPaymentWithoutFee}
                splitPaymentTotal={guestSplitPaymentTotal}
                displaySplitPayments={displaySplitPayments}
                bookingCreatedDate={bookingCreatedDate}
                masterContract={masterContract}
              />

              {isVatEnabled && isVatCountry && (
                <div className='flex space-between middle column-sm margin-lg-top'>
                  <div className='text-gray-dark'>
                    <span>
                      <FormattedMessage {...intlTaxFeeCopy[taxIntlKey]} />
                    </span>
                    {iosWebView ? (
                      <div className='flex column'>
                        {map(invoiceIds, (invoiceId) => {
                          const entry = get(
                            monthlyInvoices,
                            `${invoiceId}[0]`,
                            {}
                          );
                          const month = get(entry, 'month', '');
                          const monthName = moment(month, 'MM')
                            .locale(locale)
                            .format('MMMM');
                          const invoiceCountry = get(
                            entry,
                            'billing_country',
                            ''
                          );
                          const countryName = get(
                            allCountries,
                            `[${invoiceCountry}].name`,
                            ''
                          );
                          const year = get(entry, 'year', '');
                          const feeName = get(entry, 'fee_name', '');

                          return (
                            <a
                              href='#'
                              rel='noreferrer noopener'
                              onClick={(e) => {
                                this.props.downloadTaxInvoicePdf(
                                  e,
                                  invoiceId,
                                  monthName,
                                  countryName,
                                  year,
                                  feeName
                                );
                              }}
                            >
                              <FormattedMessage
                                {...intlViewInvoiceLinkTextWebview[feeName]}
                              />
                              :
                              <span className='margin-sm-left'>
                                {monthName} {year}
                              </span>
                            </a>
                          );
                        })}
                      </div>
                    ) : (
                      <span>
                        &nbsp;
                        <a href='/account/taxes'>
                          <FormattedMessage
                            {...intlViewInvoicesLinkText[taxIntlKey]}
                          />
                        </a>
                      </span>
                    )}
                  </div>
                </div>
              )}

              {!isHost && (
                <div>
                  <h4 className='section-header'>
                    <FormattedMessage
                      id='inbox.current_details_main.payments'
                      defaultMessage='Payments'
                    />
                  </h4>
                  <h5 className='padding-lg-top'>
                    <FormattedMessage
                      id='inbox.current_details_main.processed'
                      defaultMessage='Processed'
                    />
                  </h5>
                  <PaymentsTable payments={processedPayments} intl={intl} />
                  {!!upcomingPayments.length && (
                    <div className='margin-xl-top'>
                      <h5>
                        <FormattedMessage
                          id='inbox.current_details_main.upcoming'
                          defaultMessage='Upcoming'
                        />
                      </h5>
                      <PaymentsTable payments={upcomingPayments} intl={intl} />
                    </div>
                  )}
                  <hr />
                  <div className='flex space-between middle column-sm'>
                    <img
                      className='brand-logo-dark'
                      src='/web-2/assets/images/ps_logo_dark.svg?v=rb'
                      alt={intl.formatMessage({
                        id: 'inbox.current_details_main.peerspace_desc',
                        defaultMessage:
                          'Peerspace | Unique venues for meetings, events, photo &amp; film shoots'
                      })}
                    />
                    <div className='text-gray-dark text-right company-address'>
                      <FormattedMessage
                        id='inbox.current_details_main.company_address'
                        defaultMessage='{address}'
                        values={{ address: companyAddress }}
                      />
                    </div>
                  </div>
                </div>
              )}
              {!iosWebView && !isHostUpdate && (
                <div className='cta-buttons flex'>
                  <CTAButton
                    onClickAction={redirectToInboxDetails}
                    buttonText={intl.formatMessage({
                      id: 'inbox.current_details_main.done',
                      defaultMessage: 'Done'
                    })}
                    classNameString='done-button btn btn-default'
                    isDisabled={false}
                    attributes={{ 'data-html2canvas-ignore': 'true' }}
                  />
                </div>
              )}
            </div>
            <div className='col-xs-12 col-lg-4'>
              <div className='activity-details'>
                <BookingSummary
                  booking={activityDetailBooking}
                  profile={profile}
                  intl={intl}
                  iosWebViewConfig={{
                    isWebView: iosWebView
                  }}
                />
              </div>
              {!isVatEnabled &&
                'GB' === get(activityDetailBooking, 'listing.country', '') && (
                  <VatMessage isHost={isHost} />
                )}
            </div>
          </div>
        </div>
      </SharedIntlProviderHOC>
    );
  }
}

CurrentDetailsMain.propTypes = {
  booking: PropTypes.object,
  subtotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  cleaningFee: PropTypes.string,
  currency: PropTypes.string,
  activityDetailBooking: PropTypes.object,
  spaceRentalTotal: PropTypes.number,
  processingFee: PropTypes.number,
  iosWebView: PropTypes.bool,
  toggleModal: PropTypes.func,
  isHost: PropTypes.bool,
  masterContract: PropTypes.object,
  ssoId: PropTypes.string,
  whichModal: PropTypes.string,
  total: PropTypes.number,
  closeIOSModal: PropTypes.func,
  redirectToInboxDetails: PropTypes.func,
  isHostUpdate: PropTypes.bool,
  spaceRentalSubtotal: PropTypes.number,
  itemsArray: PropTypes.array,
  addOnsTotal: PropTypes.number,
  intl: intlShape
};

export default injectIntl(CurrentDetailsMain);
